import { EditApplicationSettingDetailInput } from './edit-application-setting-detail-input';

export class EditApplicationSettingInput {
    public applicationSettingEnums: Array<EditApplicationSettingDetailInput> = [];
}
